import { Route, Routes } from 'react-router-dom'
import { useCurrentUser } from '~/common'
import { AuthWrapped } from '~/modules/navigation/components'
import {
  OrganisationsPage,
  OrganisationDetailsPage,
  AddOrganisationPage,
  EditOrganisationPage,
} from '~/modules/organisations/view'
import { PATH } from '~/AppRoutes'

export const OrganisationRoutes = () => {
  const { hasRole } = useCurrentUser()
  const canAccess = hasRole('ORGANISATIONS')
  return (
    <Routes>
      <Route index element={<AuthWrapped component={OrganisationsPage} canAccess={canAccess} />} />
      <Route
        path={`${PATH.DETAILS}/:id`}
        element={<AuthWrapped component={OrganisationDetailsPage} canAccess={canAccess} />}
      />
      <Route path={PATH.ADD} element={<AuthWrapped component={AddOrganisationPage} canAccess={canAccess} />} />
      <Route
        path={`${PATH.EDIT}/:id`}
        element={<AuthWrapped component={EditOrganisationPage} canAccess={canAccess} />}
      />
    </Routes>
  )
}

export const organisationLinks = {
  organisationsLink: () => PATH.OVERVIEW,
  organisationDetailsLink: (id: string) => `/${PATH.DETAILS}/${id}`,
  addOrganisationLink: () => `/${PATH.ADD}`,
  editOrganisationLink: (id: string) => `/${PATH.EDIT}/${id}`,
}
